import { Navigate, Outlet } from 'react-router-dom';
import { useUsersStore } from '@/stores/users';
import { ERouterNames } from '@/types';

/**
 * Guards the organization-level pages: they belong to super admins and to
 * organization admins, neither of which is an institution role, so
 * AccessControlLayout cannot express the check.
 * @returns The guarded routes, redirecting anyone else away.
 */
export const OrganizationAccessLayout = () => {
  const { isSuperAdmin, orgAdminOrganizationIds } = useUsersStore((state) => ({
    isSuperAdmin: state.checkIsSuperAdmin(),
    orgAdminOrganizationIds: state.getOrgAdminOrganizationIds(),
  }));

  const hasAccess = isSuperAdmin || !!orgAdminOrganizationIds.length;

  if (!hasAccess) return <Navigate to={ERouterNames.ROUTE_ME} replace />;

  return <Outlet />;
};
